export default __webpack_public_path__ + "static/media/user-face.b3cebb74.svg";